// extracted by mini-css-extract-plugin
module.exports = {"input":"RightPanel_input__ef6CF"};